import React, {Component} from 'react'
import PaperBlock from '../../ui/PaperBlock'

import DewarImage from "./DewarImage.png"

import {List, ListItem, ListItemIcon, ListItemText} from '@material-ui/core'

/**
 * dewars - список коробок {id, code}.
 * selected - выбранная коробка.
 * onDewarClick(dewar) - сработает по клику на коробку.
 * onDewarDoubleClick(dewar) - двойной клик на коробку.
 */

class DewarsList extends Component {

    render() {
        let dewars = this.props.dewars ? this.props.dewars : []
        return <PaperBlock >
            <List>
                {dewars.map((dewar, n) => {
                    return <ListItem
                        key={n}
                        button
                        selected = {this.props.selected ? this.props.selected.id === dewar.id : false}
                        onClick = {e => {
                            e.stopPropagation()
                            if (typeof this.props.onDewarClick === "function") {
                                this.props.onDewarClick(dewar)
                            }
                        }}
                        onDoubleClick={e => {
                            e.stopPropagation()
                            if (typeof this.props.onDewarDoubleClick === "function") {
                                this.props.onDewarDoubleClick(dewar)
                            }
                        }}
                    >
                        <ListItemIcon>
                            <img src={DewarImage} width={32} alt="show"/>
                        </ListItemIcon>
                        <ListItemText primary={dewar.code} />
                    </ListItem>
                })}
            </List>
        </PaperBlock>
    }

}

export default DewarsList